<template>
  <v-app id="app">
    <v-content>
    <router-view></router-view>
     <!-- <audio-player class="mt-5" :url="x" playerid="audio-player"> </audio-player> -->
  </v-content>
  </v-app>
</template>

<script>


export default {
  name: 'App',
  data:()=>{
    return {
      x: 'https://lex-audio.useremarkable.com/mp3/word_us_1.mp3',
    }
  },

  components: {
    
  },


};
</script>
<style scoped>
@import '../src/assets/css/LevelTest/style.css';
</style>
<style  scoped>
@font-face {
  font-family: 'Montserrat';
  src: url('./assets/Monsterrat/Montserrat-Regular.ttf') format('truetype');
}
</style>